import { ArrowRightOutlined } from '@ant-design/icons';
import type { UserSummary } from '@cult/schemas';
import { Flex } from 'antd';
import type { ReactNode } from 'react';
import { UserChip } from '../UserChip/UserChip';
import styles from './SenderRecipient.module.scss';

type Props = {
  author: UserSummary;
  receiver: UserSummary;
  avatarSize?: number;
  /** Trailing inline content, e.g. the posted time. */
  children?: ReactNode;
  className?: string;
};

export const SenderRecipient = ({ author, receiver, avatarSize, children, className }: Props) => (
  <Flex align="center" gap={8} wrap className={className}>
    <UserChip user={author} size={avatarSize} />
    <ArrowRightOutlined className={styles.arrow} />
    <UserChip user={receiver} size={avatarSize} />
    {children}
  </Flex>
);
